import PocketBase from 'pocketbase';

const pb = new PocketBase('https://pocketbase.john5bb.com');

export default pb;
